import { Brain, Clock, Globe, TrendingUp } from "lucide-react";
import { RandomFact } from "../../types";
import { Section, SectionHeading, accent, accentFor, cn } from "../ui";

const RandomFacts = () => {
  const facts: RandomFact[] = [
    {
      id: 1,
      text: 'The human brain contains approximately 86 billion neurons.',
      category: 'Biology',
      icon: <Brain size={20} aria-hidden="true" />
    },
    {
      id: 2,
      text: 'A year on Mercury is just 88 days long.',
      category: 'Astronomy',
      icon: <Globe size={20} aria-hidden="true" />
    },
    {
      id: 3,
      text: 'The Eiffel Tower can be 15 cm taller during the summer due to thermal expansion.',
      category: 'Physics',
      icon: <TrendingUp size={20} aria-hidden="true" />
    },
    {
      id: 4,
      text: 'The shortest war in history was between Britain and Zanzibar in 1896, lasting only 38 minutes.',
      category: 'History',
      icon: <Clock size={20} aria-hidden="true" />
    }
  ];

  return (
    <Section tone="blue">
      <SectionHeading
        align="center"
        eyebrow="Facts"
        eyebrowAccent={accent('green').rule}
        title="Did You Know?"
        description="Fascinating facts from various fields of knowledge"
      />

      {/* A hairline grid rather than four floating cards — the facts read as one
          list instead of four competing panels. The subject drives the colour
          through `accentFor`, so Biology is the same hue here as it would be on
          a course card, and the label still spells the subject out. */}
      <ul className="mx-auto grid max-w-4xl grid-cols-1 gap-px overflow-hidden rounded-lg border border-border bg-border sm:grid-cols-2">
        {facts.map((fact) => {
          const palette = accentFor(fact.category);

          return (
            <li key={fact.id} className="flex items-start gap-4 bg-background-card p-6">
              <span
                aria-hidden="true"
                className={cn(
                  'flex h-11 w-11 shrink-0 items-center justify-center rounded-lg',
                  palette.soft,
                  palette.text,
                )}
              >
                {fact.icon}
              </span>
              <div>
                <span className={cn('block text-overline font-semibold uppercase', palette.text)}>
                  {fact.category}
                </span>
                <p className="mt-1.5 text-body text-text-primary">{fact.text}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </Section>
  );
};

export default RandomFacts
